<div class="topnav">
  <div class="container-fluid">
    <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
      <div class="collapse navbar-collapse justify-content-center" id="topnav-menu-content">
        <ul class="navbar-nav">

          <li *ngFor="let item of filteredMenuItems; let i = $index" class="nav-item"
            [ngClass]="{'dropdown': hasItems(item)}" [class.menu-disabled]="item.disabled"
            [title]="item.disabled ? 'Accès restreint' : ''" (mouseleave)="closeMenu($event)">

            <a class="link_menu nav-link"
              style="font-size: 16px; text-transform: uppercase; color: #1D1D35; font-weight: bold;"
              [ngClass]="{'dropdown-toggle': hasItems(item), 'arrow-none': true}" href="javascript:void(0)"
              [routerLink]="item.disabled ? null : item.link" role="button"
              (click)="item.disabled ? $event.preventDefault() : onMenuClick($event)">
              <i class="{{ item.icon }} me-2"></i>{{ item.label | translate }}
            </a>

            <div *ngIf="hasItems(item) && !item.disabled" class="dropdown-menu row" [id]="'navmenu-' + i"
              aria-labelledby="topnav-dashboard">

              <div *ngFor="let subitem of item.subItems; let j = $index">

                <!-- Sous-menu sans enfants -->
                <a *ngIf="!hasItems(subitem)" class="col dropdown-item side-nav-link-ref"
                  [class.menu-disabled]="subitem.disabled" [routerLink]="subitem.disabled ? null : subitem.link"
                  routerLinkActive="active"
                  (click)="subitem.disabled ? showAccessDenied(subitem, $event) : onMenuClick($event)">
                  <i *ngIf="subitem.disabled" class="ri-lock-line me-1 text-danger"></i>
                  {{ subitem.label }}
                </a>

                <!-- Sous-menu avec enfants -->
                <!-- Sous-menu avec enfants -->
                <div *ngIf="hasItems(subitem)" class="dropdown">
                  <a class="dropdown-item" [class.menu-disabled]="subitem.disabled"
                    (click)="subitem.disabled ? showAccessDenied(subitem, $event) : onMenuClick($event)">
                    {{ subitem.label }}
                    <div class="arrow-down"></div>
                  </a>

                  <div class="dropdown-menu dropdown-menu-end" *ngIf="!subitem.disabled">
                    <!-- ^ ajout de dropdown-menu-end ici -->
                    <ng-template ngFor let-subSubitem [ngForOf]="subitem.subItems">
                      <a class="dropdown-item side-nav-link-ref" [class.menu-disabled]="subSubitem.disabled"
                        [routerLink]="subSubitem.disabled ? null : subSubitem.link" routerLinkActive="active"
                        (click)="subSubitem.disabled ? showAccessDenied(subSubitem, $event) : onMenuClick($event)">
                        <i *ngIf="subSubitem.disabled" class="ri-lock-line me-1 text-danger"></i>
                        {{ subSubitem.label }}
                      </a>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>

          </li>
        </ul>
      </div>
    </nav>
  </div>
</div>

<!-- <div class="topnav" *ngIf="acces?.code === 'recherche-valorisation'">
  <div class="container-fluid">
    <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
      <div class="collapse navbar-collapse justify-content-center" id="topnav-menu-content">
        <ul class="navbar-nav">
          <li *ngFor="let item of menuItems; let i = $index" class="nav-item" [ngClass]="{'dropdown': hasItems(item)}">
            <a style="font-size: 16px;text-transform: uppercase; color: #E71E25; font-weight: bold;" class="nav-link" [ngClass]="{'dropdown-toggle': hasItems(item), 'arrow-none': true}" href="javascript: void(0);" [routerLink]="item.link" role="button" (click)="onMenuClick($event)">
              <i class="{{ item.icon }} me-2"></i>{{ item.label | translate }}
           <div *ngIf="hasItems(item) && i !== 0" class="arrow-down"></div> 
            </a>
            <div *ngIf="hasItems(item) && i !== 0" class="dropdown-menu row" aria-labelledby="topnav-dashboard" id="navmenu">
              <div *ngFor="let subitem of item.subItems; let j = $index">
                <div *ngIf="hasItems(subitem)" class="dropdown">
                  <a style="color: gray; font-weight: 500; text-transform: uppercase;" class="dropdown-item" (click)="onMenuClick($event)">{{ subitem.label | translate }}
                    <div class="arrow-down"></div>
                  </a>
                  <div class="dropdown-menu">
                    <ng-template ngFor let-subSubitem [ngForOf]="subitem.subItems">
                      <a style="color: gray; font-weight: 500; text-transform: uppercase;" class="dropdown-item side-nav-link-ref" [routerLink]="subSubitem.link" routerLinkActive="active">{{ subSubitem.label | translate }}</a>
                    </ng-template>
                  </div>
                </div>
                <a *ngIf="!hasItems(subitem)" style="color: rgb(68, 57, 57); font-weight: 500;" class="col dropdown-item side-nav-link-ref" [routerLink]="subitem.link" routerLinkActive="active">{{ subitem.label | translate }}</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</div> -->